import { useEffect } from "react";
import { site } from "@/data/store";

export default function RefundPolicy() {
  const policy = site.refundPolicy;

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = `${policy.title} — ${site.brandName}`;
  }, [policy.title]);

  return (
    <main data-testid="refund-policy-page" className="mx-auto max-w-[1440px] px-5 py-16 sm:px-8 lg:px-12 lg:py-24">
      <div className="fade-up max-w-2xl">
        <p className="text-[11px] uppercase tracking-[0.24em] text-black/50">{policy.lastUpdated}</p>
        <h1 className="mt-4 font-serif text-5xl font-light sm:text-6xl">{policy.title}</h1>
        <div className="mt-12 border-t border-black/15">
          {policy.sections.map((s, i) => (
            <section key={s.heading} data-testid={`refund-section-${i}`} className="border-b border-black/15 py-8">
              <h2 className="font-serif text-2xl">{s.heading}</h2>
              {s.paragraphs?.map((p) => (
                <p key={p} className="mt-3 text-base leading-relaxed text-black/65">{p}</p>
              ))}
              {s.bullets && (
                <ul className="mt-4 space-y-2">
                  {s.bullets.map((b) => (
                    <li key={b} className="flex gap-3 text-base leading-relaxed text-black/65">
                      <span className="mt-3 h-px w-3 shrink-0 bg-black" />{b}
                    </li>
                  ))}
                </ul>
              )}
            </section>
          ))}
        </div>
      </div>
    </main>
  );
}
